<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" viewBox="0 0 43 42" fill="none">
    <circle cx="21.4155" cy="21" r="20" stroke="url(#paint0_linear_11957_25702)" stroke-width="2" />
    <path
      d="M22.5264 11C22.5264 11.6137 22.029 12.1111 21.4153 12.1111C20.8017 12.1111 20.3042 11.6137 20.3042 11C20.3042 10.3864 20.8017 9.88889 21.4153 9.88889C22.029 9.88889 22.5264 10.3864 22.5264 11Z"
      fill="url(#paint1_linear_11957_25702)"
    />
    <path d="M21.4155 32.1111V16.5556" stroke="url(#paint2_linear_11957_25702)" stroke-width="2" />
    <defs>
      <linearGradient
        id="paint0_linear_11957_25702"
        x1="18.5973"
        y1="-10.2727"
        x2="53.1642"
        y2="-1.63101"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" class="gradient-start" />
        <stop offset="1" class="gradient-end" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11957_25702"
        x1="21.2587"
        y1="9.26263"
        x2="23.1791"
        y2="9.74272"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" class="gradient-start" />
        <stop offset="1" class="gradient-end" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11957_25702"
        x1="21.8451"
        y1="12.1717"
        x2="22.763"
        y2="12.1865"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" class="gradient-start" />
        <stop offset="1" class="gradient-end" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.gradient-start {
  stop-color: #4478ff;
}

.gradient-end {
  stop-color: #45b2ff;
}

.icon-success {
  .gradient-start {
    stop-color: #4fcd61;
  }

  .gradient-end {
    stop-color: #278f36;
  }
}

.icon-danger {
  .gradient-start {
    stop-color: #df252a;
  }

  .gradient-end {
    stop-color: #a20004;
  }
}
</style>
